import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../adm_mypageAside";
import UIDatePicker from 'components/datepicker';
import Button from 'components/buttons/';
import UISelect from 'components/selectbox/UISelect';
import codeDataStore from "common/codedata/store/CodeDataStore";
import paramStore from "common/page/store/ParamStore";
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UIUtils from "utils/UIUtils";

function ContentsContainer() { 
	const location = useLocation();
	const history = useHistory();
	let receivedData = (location.state as any)?.data;

	const [totalRowCnt, setTotalRowCnt] = useState(0);
	const [showRowCnt, setShowRowCnt] = useState(20); //기본 row count
	
	const [startDate, setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate, setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [absnItem, setAbsnItem] = useState('');
		
	const [dateNum, setDateNum] = useState(0); 
	const paramJson = useRef<string>("");

	let pageNum = useRef<number>(1);
	const rowCnt = useRef<string>("20");
	const totalCnt = useRef<string>("");
	
	var ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"CustomScroll": 3,
				"Height": "759px",		   
			},

			//틀고정 좌측 컬럼 설정
			"Cols": [
				{"Header": "NO",	"Type": "Int",	"Name": "SEQ",	"RelWidth": 0.7, "Align": "Center",	"CanEdit": 0},
				{
					"Header": {
						"Value": "",
						"HeaderCheck": 1, //헤더(Header)에 체크박스 생성
						"IconAlign": "Center" //체크박스 가운데 정렬
					},
					"Type" : "Bool",
					"Name": "chk",
					"RelWidth": 0.5,
					"Align": "Center",
					"CanEdit": 1,
					"BoolIcon": 4,
				},
				{"Header": "등록자",	"Type": "Text",	"Name": "SAN_PERSON_NM",		"RelWidth": 2, 	"Align": "Center",	"CanEdit": 0},
				{"Header": "대결자",	"Type": "Text",	"Name": "REP_SAN_PERSON_NM",	"RelWidth": 2, 	"Align": "Center",	"CanEdit": 0},
				{"Header": "부재기간",	"Type": "Text",	"Name": "REP_PERIOD",			"RelWidth": 3,	"Align": "Center",	"CanEdit": 0},
				{"Header": "부재항목",	"Type": "Enum", "Name": "ABSN_ITEM", 			"RelWidth": 2,	"Align": "Center",	"CanEdit": 0, "Enum": "|휴가|출장", "EnumKeys": "|1|2"},
				{"Header": "등록일시",	"Type": "Date",	"Name": "REG_DATE", 			"RelWidth": 2,	"Align": "Center",	"CanEdit": 0, "Format": "yyyy-MM-dd HH:mm:ss", "DataFormat": "yyyy-MM-dd HH:mm:ss"},
				{"Header": "REP_SAN_ID","Type": "Text",	"Name": "REP_SAN_ID",			"RelWidth": 1, 	"Visible" : 0},
			],
		},

		//시트 이벤트
		'event':{
			onRenderFirstFinish:function(evtParam) {
				doSearch('init');
			},
			
			onDblClick:function(evtParam) {
				var sheet = evtParam.sheet;
				var row = sheet.getFocusedRow();
				sheet.selectRow(row, 1);
				
				// @ts-ignore
				var vREP_SAN_ID = row["REP_SAN_ID"];
				let dataToSend = {vREP_SAN_ID};
				paramStore.deleteParam("adm0102");
				paramStore.setParam("adm0102", dataToSend);
		
				history.push({
					pathname: 'adm0102',
				});
			},
			
			onRenderFinish:function(evtParam) {
				if(receivedData !== undefined ){
					if(receivedData.PARAM_DATA !== undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.PARAM_PAGE);
					}
				}
			},
			
			onAfterGotoPage:function(evtParam) { 
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				pageNum.current = page; //페이지 번호 저장용
				paramSetting();
				
				//@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}
			},	

			onAfterSort:function(evtParam) {
				var sheet = evtParam.sheet;
				sheet.goToPageByIndex(1);
				if(sheet.getShownRows().length !== 0){
					sheet.focus(sheet.getShownRows()[0], "SEQ");
				}
			},
		},

		//시트객체 생성
		'create':function() {
			let options = this.init;
		
			if(receivedData !== undefined ){
				if(receivedData.PARAM_DATA !== undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
					options.Cfg.PageLength = receivedData.PARAM_ROW_CNT;
				}
			}

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'ap_rep_san', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			
			//@ts-ignore
			window.currentPage = -1;
		},

		'data':[]
	}
		
	const paramSetting = () => {
		let PARAM_DATA = paramJson.current;
		let PARAM_PAGE = pageNum.current;
		let PARAM_ROW_CNT = rowCnt.current;
		let dataToSend = {PARAM_DATA, PARAM_PAGE, PARAM_ROW_CNT};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm0100',
			state: { data: dataToSend }
		});
	}

	function dateToStr(dateText) {
		if(dateText == null) return '';
		let year = dateText.substring(0,4);
		let month = dateText.substring(4,6);
		let day = dateText.substring(6,8);

		return year+'-'+month+'-'+day;
	}

	async function SetDate(value){
		const newEndDate = new Date();
		setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
		const newStartDate = new Date(newEndDate);
		newStartDate.setDate(newEndDate.getDate() - value);
		setStartDate(newStartDate);  // 시작 날짜를 조정
	}
	
	const setSearchData = (type:string) => {
		let param:any = {};
		param = {
			"SRCH_ST_DATE" : DateUtil.toDateFormat(startDate, "YYYY-MM-DD"),
			"SRCH_EN_DATE" : DateUtil.toDateFormat(endDate, "YYYY-MM-DD"),
			"SRCH_ABSN_ITEM": absnItem
		};

		if(type === 'init'){
			//넘어온 파라미터 바인딩
			if(receivedData !== undefined && receivedData.PARAM_DATA !== undefined){
				param = JSON.parse(receivedData.PARAM_DATA);
				if(param.SRCH_ST_DATE !== '') setStartDate(new Date(param.SRCH_ST_DATE));
				if(param.SRCH_EN_DATE !== '') setEndDate(new Date(param.SRCH_EN_DATE));
				if(param.SRCH_ABSN_ITEM !== '') setAbsnItem(param.SRCH_ABSN_ITEM);
				rowCnt.current = receivedData.PARAM_ROW_CNT;
				setShowRowCnt(Number(rowCnt.current));
			}
		} else {
			pageNum.current = 1;
		}
		paramJson.current = JSON.stringify(param);
		paramSetting();
		return param;
	}	
	
	async function doSearch(sAction:string) {
		let param = setSearchData(sAction);
		const response:any = await CommonUtil.execute({
			url:"adm_0100_r001",
			data: param
		}).then((response: any) => {
			const rec1 = response.REC1;

			totalCnt.current = Object.keys(rec1).length+'';
			setTotalRowCnt(Object.keys(rec1).length);
			
			ib.data = rec1;

			// @ts-ignore
			Main_sheet.loadSearchData(rec1);	
			// @ts-ignore
			Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(Main_sheet.getPageIndex(Main_sheet.getFocusedPage()) + 1); // 페이지 초기화   			
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});	        
		
	};      

	async function doDel() {
		// @ts-ignore
		var Main_rows = Main_sheet.getDataRows();
		// @ts-ignore
		var delItems: {REP_SAN_ID: string;}[] = [];
		// @ts-ignore
		var delItem:  {REP_SAN_ID: string;} = {};
		
		var count = 0;
		for (var i = 0; i < Main_rows.length; i++) {
			if(Main_rows[i]["chk"] ===  1){
				delItem = {
					REP_SAN_ID: Main_rows[i]["REP_SAN_ID"]
				}
				delItems.push(delItem);
				count++;
			}
		}
		if(count === 0) {
			UIUtils.alert('삭제처리할 항목을 선택하세요.').then();
			return;
		}

		if(await UIUtils.confirm(count + '건 삭제하시겠습니까?')) {
			const response:any = await CommonUtil.execute({
				url: "adm_0100_d001",
				data: {
					"REC" : delItems,
				}
			})
			.then((response: any) => {
				if(response.ERR_CD === 'S') {
					UIUtils.alert('정상처리되었습니다.').then(()=>{
						doSearch('search');
					});
				}else {
					UIUtils.alert('삭제 실패하였습니다.').then();
				}
			}).catch((error) => {
				CommonUtil.showAxiosError(error);
				return;
			});
		}
	}; 	
	
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			
			let sr = Number(totalCnt.current) // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / Number(page)); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			//console.log(ex.message);
		}
	}
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		Main_sheet.goToPageByIndex(cPage);
	}
	
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			receivedData.PARAM_ROW_CNT = e.target.value;
			rowCnt.current = e.target.value;
			pageNum.current = 1;
			
			// @ts-ignore
			IBSheet.disposeAll(true);		  
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();
		}
	};

	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch('search');
		}
	}

	const doReg = () => {
		history.push({
			pathname: "adm0101",
		});
	}

	useEffect(() => {
		if(receivedData === undefined) {
			setAbsnItem('');
		}

		codeDataStore.read("[AI]");

		// @ts-egnore
		ib.create();
		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])
	
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li><Link to="/admin/">홈</Link></li>
						<li><Link to="#">관리자페이지</Link></li>
						<li><Link to="#">마이페이지</Link></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">부재관리</h1>
						<div className="sf sf-3col">
							<div className="inner">
								<div className="sf-item sf-m-1-3">
									<p className="sf-key">부재기간</p>
									<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-root hz-gap5">
												<UIDatePicker className="hz-item" value={startDate} valueChanged={(value) => setStartDate(value)}/>
												<span className="hz-item">~</span>
												<UIDatePicker className="hz-item" value={endDate} valueChanged={(value) => setEndDate(value)}/>
											</div>
											<div className="hz-item hz-root hz-gap5">
												<button className="bt" data-color={dateNum === 1 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(0); setDateNum(1);}}>오늘</button>
												<button className="bt" data-color={dateNum === 2 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(7); setDateNum(2);}}>1주일</button>
												<button className="bt" data-color={dateNum === 3 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(30); setDateNum(3);}}>1개월</button>
												<button className="bt" data-color={dateNum === 4 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(90); setDateNum(4);}}>3개월</button>
												<button className="bt" data-color={dateNum === 5 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(180); setDateNum(5);}}>6개월</button>
												<button className="bt" data-color={dateNum === 6 ? 'pri' : 'pri-o2'} data-size="md" type="button" onClick={()=> {SetDate(365); setDateNum(6);}}>1년</button>
											</div>
										</div>
									</div>
								</div>
								<div className="sf-item">
									<p className="sf-key">부재항목</p>
									<div className="sf-value">
										<div className="sl sl-md w100p">
											<UISelect
												value={absnItem}
												valueChanged={(value) => setAbsnItem(String(value))}
												codeData={codeDataStore.get("[AI]")}
												firstName={"all"}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="hz-root hz-center mb30">
							<button className="bt" data-color="pri" data-size="md" type="button" onClick={()=> doSearch('search')}>조회</button>
						</div>

						<div className="tb-top">
							<div className="hz-root hz-gap15">
								<div className="hz-item">
									<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
								</div>
							</div>
							<div className="hz-root hz-gap5">
								<Button color="pri-o" size="sm" onClick={() => doReg()}>등록</Button>
								<Button color="pri-o" size="sm" onClick={() => doDel()}>삭제</Button>
								<div className="sl sl-sm w120">
									<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div className="ibsheet" id='ap_rep_san'></div>
						<div id="pageNavi" className="pg"></div>
					</main>
				</div>
		</PageContainer>
	);
}
export default ContentsContainer;